import {
  autocompletion,
  Completion,
  CompletionContext,
} from "@codemirror/autocomplete";
import { Extension } from "@codemirror/state";
import { globalCompletion } from "@codemirror/lang-python";
/**
 * 提及变量方法
 * @param data
 * @returns
 */
export const mentionVariables = (data: Completion[] = []): Extension => {
  return autocompletion({
    override: [
      (context: CompletionContext) => {
        if (data.length === 0) return null;
        let word = context.matchBefore(/(\S*)/);
        if (!word) return null;
        if (word && word.from === word.to && !context.explicit) {
          return null;
        }
        // 处理 main 函数的捕获问题
        if (!!word?.text && /^main\(/.test(word.text)) {
          return {
            from: word?.from! + 5,
            options: [...data],
          };
        }
        return {
          from: word?.from!,
          options: [...data],
        };
      },
      globalCompletion as any,
    ],
  });
};
